import { useDesiredView } from '@apps/createWedding/hooks';
import { useAuth } from '@shared/components/AuthProvider';
import { useAutoRedriectToScenario } from './hooks/useAutoRedirectToScenario';

export const useCreateWeddingController = () => {
  const desiredView = useDesiredView();
  const { isCurrentUserSettled } = useAuth();

  useAutoRedriectToScenario();

  return { isLoading: !isCurrentUserSettled, desiredView };
};
